import { ArrayInput, SelectInput, SimpleFormIterator } from "react-admin";
import { useWatch } from "react-hook-form";

import { MEAL_TIMES_OPTIONS } from "../../utils/PlaceTypesUtils";
import { validateRequired } from "../../utils/Validations";

const MAX_MEALTIMES = 2;

const LimitedArrayInput = (props) => {
  const mealTimes = useWatch({ name: props.source }) || [];

  return (
    <ArrayInput {...props}>
      <SimpleFormIterator
        getItemLabel={(index) => `#${index + 1}`}
        disableAdd={mealTimes.length >= MAX_MEALTIMES}
      >
        <SelectInput
          choices={MEAL_TIMES_OPTIONS}
          label="Horario"
          validate={validateRequired}
        />
      </SimpleFormIterator>
    </ArrayInput>
  );
};

export default LimitedArrayInput;
